import React from 'react';
import PropTypes from 'prop-types';

import {translate, useActiveAdmins} from 'views/module';

import CompactDropdown from './CompactDropdown';

import userUtil from 'utils/miscellaneous/user/user_util';

const OwnerDropdown = (props) => {
  const {selectedOwnerRn, setSelectedOwnerRn} = props;

  const {admins, isLoading} = useActiveAdmins();

  const unassignedTitle = translate('client.ClientDetail.Status.Menu.OwnerUnassigned');
  const options = [
    {userRn: null, title: unassignedTitle},
    ...admins.map((admin) => ({userRn: admin.userRn, title: userUtil.getFullName(admin.firstName, admin.lastName)})),
  ];
  const selectedOption = options.find((option) => option.userRn === (selectedOwnerRn || null));

  return (
    <CompactDropdown
      getOptionKey={(option) => option.userRn || 'UNASSIGNED'}
      getOptionLabel={(option) => option.title}
      isOptionSelected={(option) => option === selectedOption}
      label={props.label}
      loading={isLoading}
      menuLabel={props.label}
      onOptionSelect={(option) => {
        if (option !== selectedOption) {
          setSelectedOwnerRn(option.userRn);
        }
      }}
      options={options}
      value={selectedOption ? selectedOption.title : '-'}
    />
  );
};

OwnerDropdown.propTypes = {
  label: PropTypes.string,
  selectedOwnerRn: PropTypes.string,
  setSelectedOwnerRn: PropTypes.func.isRequired,
};

export default OwnerDropdown;
